import React from 'react';

let TagSelect = ({currentFilters, setFilters}) => {

  let showTags = (e) => {
     e.target.classList.toggle("active");
    var content = e.target.nextElementSibling;
    if (content.style.display === "flex") {
      content.style.display = "none";
    } else {
      content.style.display = "flex";
    }
  };

  let handleChange = (e) => {
    console.log(e.target);
    let newFilters = {...currentFilters};
    console.log(newFilters);
    newFilters.tag[e.target.name] = e.target.value;
    setFilters(newFilters);
  }

  return (
    <div className="tag-select">

      <div className="tag-category" name="Damage Types">
        <table className="tag-table">
          <colgroup>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
          </colgroup>

          <tbody>
            <tr>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Acid" onChange={handleChange}/> Acid </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Cold" onChange={handleChange}/> Cold </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Electricity" onChange={handleChange}/> Electricity </td>
            </tr>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Force" onChange={handleChange}/>Force </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Sonic" onChange={handleChange}/>Sonic </td>
            </tr>
          </tbody>
        </table>
      </div>


      <button type="button" className="collapsible" onClick={showTags}>Elements</button>
      <div className="tag-category" name="Element">
        <table className="tag-table">
          <colgroup>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
          </colgroup>

          <tbody>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Air" onChange={handleChange}/>Air </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Earth" onChange={handleChange}/>Earth </td>
            </tr>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Fire" onChange={handleChange}/>Fire </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Water" onChange={handleChange}/>Water </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button type="button" className="collapsible" onClick={showTags}>Afflictions</button>
      <div className="tag-category" name="Affliction">
        <table className="tag-table">
          <colgroup>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
          </colgroup>

          <tbody>
            <tr>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Disease" onChange={handleChange}/>Disease </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Death" onChange={handleChange}/>Death </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Fear" onChange={handleChange}/>Fear </td>
            </tr>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Curse" onChange={handleChange}/>Curse </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Poison" onChange={handleChange}/>Poison </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button type="button" className="collapsible" onClick={showTags}>Alignment</button>
      <div className="tag-category" name="Alignment">
        <table className="tag-table">
          <colgroup>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
          </colgroup>

          <tbody>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Chaotic" onChange={handleChange}/>Chaotic </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Evil" onChange={handleChange}/>Evil </td>
            </tr>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Lawful" onChange={handleChange}/>Lawful </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Good" onChange={handleChange}/>Good </td>
            </tr>
          </tbody>
        </table>


      </div>

      <button type="button" className="collapsible" onClick={showTags}>Mental</button>
      <div className="tag-category" name="Mental">
        <table className="tag-table">
          <colgroup>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
          </colgroup>

          <tbody>
            <tr>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Emotion" onChange={handleChange}/>Emotion </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Language_Dependant" onChange={handleChange}/>Language Dependant </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Mind_Affecting" onChange={handleChange}/>Mind Affecting </td>
            </tr>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Meditative" onChange={handleChange}/>Meditative </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Pain" onChange={handleChange}/>Pain </td>
            </tr>
          </tbody>
        </table>


      </div>

      <button type="button" className="collapsible" onClick={showTags}>Other</button>
      <div className="tag-category" name="Other">
        <table className="tag-table">
          <colgroup>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
            <col span="1" className="tag-column"/>
          </colgroup>

          <tbody>
            <tr>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Light" onChange={handleChange}/>Light </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Darkness" onChange={handleChange}/>Darkness </td>
              <td className="tag-box" colSpan="2"><input type="checkbox" className="tag-box" defaultChecked="false" name="Draconic" onChange={handleChange}/>Draconic </td>
            </tr>
            <tr>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Ruse" onChange={handleChange}/>Ruse </td>
              <td className="tag-box" colSpan="3"><input type="checkbox" className="tag-box" defaultChecked="false" name="Language Dependant" onChange={handleChange}/>Shadow </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TagSelect;